import $api from "@/frontend/shared/api/axios";
import { TPipeline } from "../types/types";
import { PipelinesSchema } from "@/libs/models/pipelines";

export async function getPipelines() {
  const res = await $api.get<{ data: TPipeline[] }>("/pipelines");
  const parsed = PipelinesSchema.parse(res.data.data);
  return parsed;
}
